import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { StartComponent } from './pages/start/start.component';
import { ImeiComponent } from './pages/imei/imei.component';
import { ProductComponent } from './pages/product/product.component';
import { PersonalInfoComponent } from './pages/personal-info/personal-info.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { CompleteComponent } from './pages/complete/complete.component';
import { UserInfoComponent } from './pages/user-info/user-info.component';
import { ImeiWithEmailComponent } from './pages/imei-with-email/imei-with-email.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { RecaptchaComponent } from './samples/recaptcha/recaptcha.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CancellationDialogComponent } from './dialogs/cancellation-dialog/cancellation-dialog.component';
import { ResendDialogComponent } from './dialogs/resend-dialog/resend-dialog.component';
import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { OrderSummaryDialogComponent } from './dialogs/order-summary-dialog/order-summary-dialog.component';
import { SpinnerDialogComponent } from './dialogs/spinner-dialog/spinner-dialog.component';
import {InvalidTicketDialogComponent} from './dialogs/invalid-ticket-dialog/invalid-ticket-dialog.component';
import { AmazonComponent } from './pages/amazon/amazon.component';
import {AmazonRegisterFormCeQaComponent} from './pages/amazon/ce/qa/amazon-register-form-ce-qa.component';
import {AmazonRegisterFormCeProdComponent} from './pages/amazon/ce/prod/amazon-register-form-ce-prod.component';
import {AmazonRegisterFormMxQaComponent} from './pages/amazon/mx/qa/amazon-register-form-mx-qa.component';
import {AmazonRegisterFormMxProdComponent} from './pages/amazon/mx/prod/amazon-register-form-mx-prod.component';

// import { NumbersOnlyDirective } from './directive/NumbersOnlyDirective'

@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    ImeiComponent,
    ProductComponent,
    PersonalInfoComponent,
    PaymentComponent,
    CompleteComponent,
    UserInfoComponent,
    ImeiWithEmailComponent,
    TermsAndConditionsComponent,
    RecaptchaComponent,
    CancellationDialogComponent,
    ResendDialogComponent,
    MessageDialogComponent,
    OrderSummaryDialogComponent,
    NotfoundComponent,
    SpinnerDialogComponent,
    InvalidTicketDialogComponent,
    AmazonComponent,
    // NumbersOnlyDirective,
    AmazonRegisterFormCeQaComponent,
    AmazonRegisterFormCeProdComponent,
    AmazonRegisterFormMxQaComponent,
    AmazonRegisterFormMxProdComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
